import { useEffect } from "react";
import { Routes, Route, Navigate, useLocation, Link } from "react-router-dom";
import { useSession } from "./lib/partner-client";
import { LoginPage } from "./pages/login";
import { DashboardPage } from "./pages/dashboard";
import { OutcomesListPage } from "./pages/outcomes-list";
import { CredentialsPage } from "./pages/credentials";
import { InviteAcceptPage } from "./pages/invite-accept";

export function App() {
  const bootstrap = useSession((s) => s.bootstrap);
  const loaded = useSession((s) => s.loaded);
  const token = useSession((s) => s.token);

  useEffect(() => {
    bootstrap();
  }, [bootstrap]);

  if (!loaded) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-neutral-300 border-t-neutral-900" />
      </div>
    );
  }

  return (
    <>
      {token ? <Header /> : null}
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/invite/:token" element={<InviteAcceptPage />} />
        <Route
          path="/"
          element={
            <RequireSession>
              <DashboardPage />
            </RequireSession>
          }
        />
        <Route
          path="/outcomes"
          element={
            <RequireSession>
              <OutcomesListPage />
            </RequireSession>
          }
        />
        <Route
          path="/credentials"
          element={
            <RequireSession>
              <CredentialsPage />
            </RequireSession>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}

function RequireSession({ children }: { children: React.ReactNode }) {
  const token = useSession((s) => s.token);
  const location = useLocation();
  if (!token) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }
  return <>{children}</>;
}

function Header() {
  const clientId = useSession((s) => s.clientId);
  const logout = useSession((s) => s.logout);
  return (
    <header className="border-b border-neutral-200 bg-white dark:border-neutral-800 dark:bg-neutral-950">
      <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-3">
        <Link to="/" className="text-sm font-semibold">
          AppSumo Outcomes — Dev Portal
        </Link>
        <nav className="flex items-center gap-4 text-sm">
          <Link to="/" className="hover:underline">
            Dashboard
          </Link>
          <Link to="/outcomes" className="hover:underline">
            Outcomes
          </Link>
          <Link to="/credentials" className="hover:underline">
            Credentials
          </Link>
          <span className="font-mono text-xs text-neutral-500">
            {clientId?.slice(0, 12)}…
          </span>
          <button
            onClick={logout}
            className="text-xs text-neutral-500 hover:underline"
          >
            Log out
          </button>
        </nav>
      </div>
    </header>
  );
}
